/**
 * ArticlesSection
 * Sección de artículos/fichas del capítulo
 */
import React, { memo } from "react";
import { motion } from "framer-motion";
import { Trans } from "react-i18next";
import CloseButton from "../../shared/components/CloseButton";

// Componente FichaCard memoizado para evitar re-renders innecesarios
const FichaCard = memo(({ ficha, currentLanguage, backendBaseUrl }) => {
    const fichaData = ficha[currentLanguage];
    const images = fichaData.images || [];
    const firstImage = images.length ? images[0] : null;
    const remainingImages = images.length > 1 ? images.slice(1) : [];

    return (
        <div className="bg-gray-800 text-white p-4 rounded-lg shadow-md my-4">
            {firstImage && (
                <img
                    src={`${backendBaseUrl}${firstImage}`}
                    alt="Ficha 1"
                    className="w-full h-auto object-contain rounded-lg shadow-md mb-4"
                />
            )}
            <h3 className="text-lg font-bold">{fichaData.title}</h3>
            <p
                className="text-sm mb-4"
                dangerouslySetInnerHTML={{
                    __html: fichaData.text.replace(/\n/g, "<br>"),
                }}
            ></p>
            {remainingImages.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {remainingImages.map((img, i) => (
                        <img
                            key={i}
                            src={`${backendBaseUrl}${img}`}
                            alt={`Ficha ${i + 2}`}
                            className="w-full h-auto object-contain rounded-lg shadow-md"
                        />
                    ))}
                </div>
            )}
        </div>
    );
});

FichaCard.displayName = "FichaCard";

const ArticlesSection = ({ currentSection, chapterTitle, fichas, currentLanguage, backendBaseUrl }) => {
    return (
        <motion.div
            key={`${currentSection}-articulos`}
            className="absolute inset-0 flex flex-col items-center justify-start text-left bg-black bg-opacity-90 overflow-y-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
        >
            <CloseButton />
            <h1 className="text-3xl font-bold text-white mt-8 mb-4 text-center">
                <Trans i18nKey="articles" />: {chapterTitle}
            </h1>
            <div className="w-full max-w-4xl px-4">
                {fichas && fichas.map((ficha, index) => (
                    <FichaCard
                        key={index}
                        ficha={ficha}
                        currentLanguage={currentLanguage}
                        backendBaseUrl={backendBaseUrl}
                    />
                ))}
            </div>
        </motion.div>
    );
};

export default memo(ArticlesSection);
